import JustValidate from 'just-validate';
export class LoanPayment {

	constructor() {
	}
	init() {
		const calculators = document.querySelectorAll('.calculator-section.type-loan_payment');
		if (!calculators) {
			return;
		}

		calculators.forEach(calculator => {
			const submitButton = calculator.querySelector('button[type=submit]');
			const mobileResults = calculator.querySelector('.results-mobile');
			const mobileResultsSelect = calculator.querySelector('#repayment-terms-select');
			const form = calculator.querySelector('form');
			let submittedOnce = false;
			const validator = new JustValidate(form, {
				validateBeforeSubmitting: false,
			});
			validator.addField('#amount', [
				{
					rule: 'required',
					errorMessage: 'Please enter an amount for amount to borrow'
				},
				{
					rule: 'number',
					errorMessage: 'Please enter a valid number'
				},
				{
					rule: 'minNumber',
					value: 1500,
					errorMessage: 'Please enter a number greater than $1,499'
				},
				{
					rule: 'maxNumber',
					value: 100000,
					errorMessage: 'Please enter a number less than $100,000'
				}
			]);
			validator.addField('#years_before', [
				{
					rule: 'required',
					errorMessage: 'Please enter years before graduation'
				}
			]);
			validator.addField('#borrower-credit', [
				{
					rule: 'required',
					errorMessage: 'Please select a credit rating profile'
				}
			]);
			validator.onSuccess((e) => {
				this.processForm(calculator, submittedOnce);
				submittedOnce = true;
				const mobileResultsSelect = calculator.querySelector('#repayment-terms-select');

				let amountField = calculator.querySelector('input[name=amount]');
				amountField.addEventListener('change', () => {
					console.log("changed");
					this.processForm(calculator, submittedOnce);
				});
				calculator.querySelectorAll('select').forEach((el) => {
					el.addEventListener('change', () => {
						this.processForm(calculator, submittedOnce);
					});
				});

				const resultsContainers = calculator.querySelectorAll('.results-mobile-item');

				resultsContainers.forEach(( resItem ) => {
					const ogChart = document.querySelector('.loan-comparison-chart.monthly-comparison-chart');
					const type = resItem.dataset.type;
					const vInSchool = resItem.querySelector('.value-in-school');
					const vPostSchool = resItem.querySelector('.value-post-school');
					const vTotalCost = resItem.querySelector('.value-total-cost');
					const vInterestRate = resItem.querySelector('.value-interest-rate');
					const vAPR = resItem.querySelector('.value-apr');

					// map the values
					vInSchool.innerHTML = ogChart.querySelector(`#in-school-payments .${type}`).innerHTML;
					vPostSchool.innerHTML = ogChart.querySelector(`#out-school-payments .${type}`).innerHTML;
					vTotalCost.innerHTML = ogChart.querySelector(`#total-loan-cost .${type}`).innerHTML;
					vInterestRate.innerHTML = ogChart.querySelector(`#interest-rate .${type}`).innerHTML;
					vAPR.innerHTML = ogChart.querySelector(`#apr-range .${type}`).innerHTML;
				});
				// let principle = calculator.querySelector('input[name=initial-deposit]').value;
				// const age = calculator.querySelector('select[name=age]').value;
				// const money = calculator.querySelector('input[name=investment]').value;

				// var r = 0.07; //yearly interest rate
				// var n = 12;   //times a year this is compounded (monthly = 12)
				// var t = (18 - age); //investment time

				// var accountAtEnd = this.calculateNumbers(principle,money,t);
				// principle = parseFloat(principle);
				// var amountContributed = principle + ( money * t*n );  //the amount contributed is just monthly investment times months invested
				// var interestContributed = accountAtEnd - amountContributed; //interest earned is total minus contributions

				// calculator.querySelector('.val-savings').innerHTML = this.mefaCommaNum(Math.floor(accountAtEnd));
				// calculator.querySelector('.val-contributions').innerHTML = this.mefaCommaNum(Math.floor(amountContributed));
				// calculator.querySelector('.val-interest').innerHTML = this.mefaCommaNum(Math.floor(interestContributed));

				mobileResultsSelect.value = mobileResultsSelect.querySelector('option').value;
				mobileResultsSelect.dispatchEvent(new Event('change'));

				calculator.querySelector('.disclaimer').classList.remove('visually-hidden');
			})
			validator.onFail((e) => {
				console.log("fail");
			});

			/** mobile change */
			mobileResultsSelect.addEventListener('change', (e) => {
				const selected = e.target.value;
				mobileResults.querySelectorAll('.results-mobile-item').forEach((item) => {
					item.classList.remove('active');
				});
				mobileResults.querySelector(`.results-mobile-item.${selected}`).classList.add('active');
			});


		});


	}

	processForm(calculator, submittedOnce){
		var monthCount = 12;
		let cost = calculator.querySelector('input[name=amount]').value;
		let year = calculator.querySelector('select[name=years_before]').value;
		let creditP = calculator.querySelector('select[name=borrower-credit]').value;

		this.mefaMonthCalc(calculator, year, monthCount);
		this.mefaShowAllMonthlys(calculator, cost, year, creditP)

		calculator.querySelector('.results').classList.remove('visually-hidden');

		//disable scroll after initial submit
		if(submittedOnce){
			return;
		}
		window.scrollTo({
			top: calculator.querySelector('.results').getBoundingClientRect().top + window.pageYOffset - 100,
			behavior: 'smooth'
		});
	}

	mefaMonthCalc(calculator, calcNum, monthCount) {
		monthCount = Number(calcNum) * 12;
		calculator.querySelectorAll('tr.monthly-calc-main td').forEach(function(el) {
			if(el.querySelector('.month-value')){
				el.querySelector('.month-value').textContent = 'for ' + monthCount + ' months';
			}
		});
		calculator.querySelectorAll('tr.monthly-calc-offset td').forEach(function(el) {
			if (el.dataset.offset) {
				let monthOffset = Number(el.dataset.offset);
				let monthRemain = monthOffset * 12 - monthCount;
				if(el.querySelector('.month-value')){
					el.querySelector('.month-value').textContent = 'for ' + monthRemain + ' months';
				}
			}
		})
	}

	mefaShowAllMonthlys(calculator, enteredCost, enteredYear, loanCreditP) {
		this.mefaDisplayCalcLoanValues(calculator, enteredCost, enteredYear, loanCreditP, 'immediate10');
		this.mefaDisplayCalcLoanValues(calculator, enteredCost, enteredYear, loanCreditP, 'immediate15');
		this.mefaDisplayCalcLoanValues(calculator, enteredCost, enteredYear, loanCreditP, 'interestonly');
		this.mefaDisplayCalcLoanValues(calculator, enteredCost, enteredYear, loanCreditP, 'deferredrepay');
		this.mefaDisplayCalcLoanValues(calculator, enteredCost, enteredYear, loanCreditP, 'deferredcobor')
	}


	mefaDisplayCalcLoanValues(calculator, enteredCost, enteredYear, loanCreditP, gName) {
		var inSchoolAmount = '0.00';
		var outSchoolAmount = '0.00';
		var inMonths = parseInt(enteredYear) * 12;
		var outMonths = 0;
		var allLoanCalc = 0;
		var allLoanAmt = '0.00';
		let intRate = 0;
		switch (loanCreditP) {
		case 'fair':
			intRate = window.MEFA_DATA.intfairrates[0][gName];
			break;
		case 'good':
			intRate = window.MEFA_DATA.intgoodrates[0][gName];
			break;
		case 'excellent':
			intRate = window.MEFA_DATA.intexcelrates[0][gName];
			break;
		default:
			intRate = ''
		}
		if (gName == 'immediate10' || gName == 'immediate15') {
			inSchoolAmount = this.mefaImmMonthlyInSchoolPayAmt(enteredCost, enteredYear, intRate, gName).toFixed(2)
		} else if (gName == 'interestonly') {
			inSchoolAmount = this.mefaIntOnlyMonthlyInSchoolPayAmt(enteredCost, enteredYear, intRate, gName).toFixed(2)
		}
		if (gName == 'immediate10' || gName == 'immediate15') {
			outSchoolAmount = this.mefaImmMonthlyOutSchoolPayAmt(enteredCost, enteredYear, intRate, gName).toFixed(2)
		} else if (gName == 'interestonly') {
			outSchoolAmount = this.mefaIntOnlyMonthlyOutSchoolPayAmt(enteredCost, enteredYear, intRate, gName).toFixed(2)
		} else if (gName == 'deferredrepay' || gName == 'deferredcobor') {
			outSchoolAmount = this.mefaDeffMonthlyOutSchoolPayAmt(enteredCost, enteredYear, intRate, gName).toFixed(2)
		}
		outMonths = (gName == 'immediate10' ? 120 : 180) - parseInt(inMonths);
		allLoanCalc = (parseFloat(inSchoolAmount) * parseInt(inMonths)) + (parseFloat(outSchoolAmount) * parseInt(outMonths));
		allLoanAmt = parseFloat(allLoanCalc).toFixed(2);
		calculator.querySelector('tr#in-school-payments td.' + gName + ' span.cost-value').textContent = this.mefaCommaNum(inSchoolAmount);
		calculator.querySelector('tr#out-school-payments td.' + gName + ' span.cost-value').textContent = this.mefaCommaNum(outSchoolAmount);
		calculator.querySelector('tr#total-loan-cost td.' + gName + ' span.cost-value').textContent = this.mefaCommaNum(allLoanAmt);
		calculator.querySelector('tr#interest-rate td.' + gName + ' span.rate-value').textContent = this.mefaPctNum(intRate, 2);
		this.mefaMinPayment(calculator.querySelector('tr#in-school-payments td.' + gName + ' span.cost-value'));
		this.mefaMinPayment(calculator.querySelector('tr#out-school-payments td.' + gName + ' span.cost-value'));

	}

	mefaCalcOrigFee(enteredCost, gName) {
		var origFee = window.MEFA_DATA.origfees[0][gName];
		if (origFee > 0) {
			return parseFloat((enteredCost / (1 - this.mefaDecNumber(mefaCalcLocal.origfees[gName]))) - enteredCost).toFixed(2)
		} else {
			return parseFloat(0).toFixed(2)
		}
	}
	mefaCalcAccrFee(partialCost, enteredYear, intRate, gName) {
		var accrDays = window.MEFA_DATA.accrdays[0][gName];
		if (gName == 'deferredrepay' || gName == 'deferredcobor') {
			accrDays = Math.round(parseFloat(enteredYear) * parseFloat(365.25)) + parseFloat(accrDays)
		}
		return (partialCost / 2 * this.mefaDecNumber(intRate) / 365.25 * parseFloat(accrDays)).toFixed(2)
	}
	mefaCalcDeffAccrFee(partialCost, enteredYear, intRate, gName) {
		var deffDays = Math.round(parseFloat(enteredYear) * parseFloat(365.25));
		return (partialCost / 2 * this.mefaDecNumber(intRate) / 365.25 * parseFloat(deffDays)).toFixed(2)
	}
	mefaTotalPrincipal(enteredCost, enteredYear, intRate, gName) {
		var totalDeffCost = 0.00;
		var totalOrigCost = this.mefaCalcOrigFee(enteredCost, gName);
		var totalAccrCost = this.mefaCalcAccrFee((parseFloat(enteredCost) + parseFloat(totalOrigCost)), enteredYear, intRate, gName);
		if (gName == 'deferredrepay' || gName == 'deferredcobor') {
			totalDeffCost = this.mefaCalcDeffAccrFee((parseFloat(enteredCost) + parseFloat(totalOrigCost)), enteredYear, intRate, gName)
		}
		return parseFloat(enteredCost) + parseFloat(totalOrigCost) + parseFloat(totalAccrCost) + parseFloat(totalDeffCost)
	}
	mefaRemainingPrincipal(enteredCost, enteredYear, intRate, gName) {
		var princAmt = this.mefaTotalPrincipal(enteredCost, enteredYear, intRate, gName);
		var inMonths = parseFloat(enteredYear) * 12;
		var totalMnt = gName == 'immediate10' ? 120 : 180;
		var totalPay = -this.mefaPMT(this.mefaDecNumber(intRate) / 12, totalMnt, princAmt, 0, 0).toFixed(2);
		for (var yearInc = 1; yearInc < (inMonths + 1); yearInc++) {
			var intPayment = (parseFloat(princAmt) * (this.mefaDecNumber(intRate) / 12)).toFixed(2);
			var PrnPayment = (parseFloat(totalPay) - parseFloat(intPayment)).toFixed(2);
			princAmt = (parseFloat(princAmt) - parseFloat(PrnPayment)).toFixed(2)
		}
		return princAmt
	}

	mefaTotalPrincipal(enteredCost, enteredYear, intRate, gName) {
		var totalDeffCost = 0.00;
		var totalOrigCost = this.mefaCalcOrigFee(enteredCost, gName);
		var totalAccrCost = this.mefaCalcAccrFee((parseFloat(enteredCost) + parseFloat(totalOrigCost)), enteredYear, intRate, gName);
		if (gName == 'deferredrepay' || gName == 'deferredcobor') {
			totalDeffCost = this.mefaCalcDeffAccrFee((parseFloat(enteredCost) + parseFloat(totalOrigCost)), enteredYear, intRate, gName)
		}
		return parseFloat(enteredCost) + parseFloat(totalOrigCost) + parseFloat(totalAccrCost) + parseFloat(totalDeffCost)
	}
	mefaImmMonthlyInSchoolPayAmt(enteredCost, enteredYear, intRate, gName) {
		var totalPrincipalAmt = this.mefaTotalPrincipal(enteredCost, enteredYear, intRate, gName);
		var totalMnt = gName == 'immediate10' ? 120 : 180;
		return -this.mefaPMT(this.mefaDecNumber(intRate) / 12, parseInt(totalMnt), parseFloat(totalPrincipalAmt), 0, 0)
	}
	mefaImmMonthlyOutSchoolPayAmt(enteredCost, enteredYear, intRate, gName) {
		var totalPrincipalAmt = this.mefaRemainingPrincipal(enteredCost, enteredYear, intRate, gName);
		var totalMnt = (gName == 'immediate10' ? 120 : 180) - (enteredYear * 12);
		return -this.mefaPMT(this.mefaDecNumber(intRate) / 12, parseInt(totalMnt), parseFloat(totalPrincipalAmt), 0, 0)
	}
	mefaIntOnlyMonthlyInSchoolPayAmt(enteredCost, enteredYear, intRate, gName) {
		var totalPrincipalAmt = this.mefaTotalPrincipal(enteredCost, enteredYear, intRate, gName);
		return (parseFloat(totalPrincipalAmt) * (this.mefaDecNumber(intRate) / 12))
	}
	mefaIntOnlyMonthlyOutSchoolPayAmt(enteredCost, enteredYear, intRate, gName) {
		var totalPrincipalAmt = this.mefaTotalPrincipal(enteredCost, enteredYear, intRate, gName).toFixed(2);
		var totalMnt = 180 - (enteredYear * 12);
		return -this.mefaPMT(this.mefaDecNumber(intRate) / 12, parseInt(totalMnt), parseFloat(totalPrincipalAmt), 0, 0)
	}
	mefaDeffMonthlyOutSchoolPayAmt(enteredCost, enteredYear, intRate, gName) {
		var totalPrincipalAmt = this.mefaTotalPrincipal(enteredCost, enteredYear, intRate, gName).toFixed(2);
		var totalMnt = 180 - (enteredYear * 12);
		return -this.mefaPMT(this.mefaDecNumber(intRate) / 12, parseInt(totalMnt), parseFloat(totalPrincipalAmt), 0, 0)
	}

	mefaPctNum(nStr, decCount) {
		var nVal = this.mefaDecStrip(nStr);
		return parseFloat(nVal).toFixed(parseFloat(decCount)) + '%'
	}

	mefaDecStrip(nStr) {
		return nStr.replace(/[^0-9\.]+/g, '')
	}

	mefaDecNumber(nIng) {
		return parseFloat(nIng) / 100
	}

	mefaMinPayment(nBlock) {
		var nVal = this.mefaDecStrip(nBlock.innerText);
		if (parseFloat(nVal) >= 1 && parseFloat(nVal) <= 49) {
			nBlock.append('*')
		}
	}

	mefaPMT(rate_per_period, number_of_payments, present_value, future_value, type) {
		if (rate_per_period !== 0.0) {
			var q = Math.pow(1 + rate_per_period, number_of_payments);
			return -(rate_per_period * (future_value + (q * present_value))) / ((-1 + q) * (1 + rate_per_period * (type)))
		} else if (number_of_payments !== 0.0) {
			return -(future_value + present_value) / number_of_payments
		}
		return 0
	}

	mefaCommaNum(nStr){
		nStr += '';
		var x = nStr.split('.');
		var x1 = x[0];
		var x2 = x.length > 1 ? '.' + x[1] : '';
		var rgx = /(\d+)(\d{3})/;
		while (rgx.test(x1)) {
			x1 = x1.replace(rgx, '$1' + ',' + '$2')
		}
		return '$' + x1 + x2
	}
	addReadableComma(num) {
		var parts = num.toString().split(".");
		parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
		return parts.join(".");
	}
}
